"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.FormWrapper = exports.TextArea = exports.StyledInput = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", "px;\n  border: 1px solid ", ";\n  background: ", ";\n  padding: ", ";\n  height: auto;\n  width: 100%;\n  line-height: 1.5;\n  border-radius: ", "px;\n\n  &:focus {\n    outline: none;\n  }\n  &::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    color: ", ";\n    font-size: ", "px;\n  }\n  &::-moz-placeholder {\n    /* Firefox 19+ */\n    color: ", ";\n    font-size: ", "px;\n  }\n  &:-ms-input-placeholder {\n    color: ", ";\n    font-size: ", "px;\n  }\n  &:-moz-placeholder {\n    /* Firefox 18- */\n    color: ", ";\n    font-size: ", "px;\n  }\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  border: 1px solid ", ";\n  background: ", ";\n  padding: ", ";\n  height: auto;\n  width: 100%;\n  line-height: 1.5;\n  border-radius: ", "px;\n\n  &:focus {\n    outline: none;\n  }\n  &::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    color: ", ";\n    font-size: ", "px;\n  }\n  &::-moz-placeholder {\n    /* Firefox 19+ */\n    color: ", ";\n    font-size: ", "px;\n  }\n  &:-ms-input-placeholder {\n    color: ", ";\n    font-size: ", "px;\n  }\n  &:-moz-placeholder {\n    /* Firefox 18- */\n    color: ", ";\n    font-size: ", "px;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral([""], [""]),
    _templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  text-align: ", ";\n  color: ", ";\n  border-radius: ", "px;\n\n  h2 {\n    margin-bottom: 30px;\n    line-height: 1;\n    @media ", " {\n      margin-bottom: 50px;\n    }\n  }\n  .toast {\n    top: 0;\n    right: 0;\n  }\n"], ["\n  background: ", ";\n  text-align: ", ";\n  color: ", ";\n  border-radius: ", "px;\n\n  h2 {\n    margin-bottom: 30px;\n    line-height: 1;\n    @media ", " {\n      margin-bottom: 50px;\n    }\n  }\n  .toast {\n    top: 0;\n    right: 0;\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  border: 1px solid ", ";\n  font-size: ", "px;\n  min-width: 155px;\n  padding: 16px 25px;\n  transition: all 0.3s ease-in-out;\n  &:hover {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  border: 1px solid ", ";\n  font-size: ", "px;\n  min-width: 155px;\n  padding: 16px 25px;\n  transition: all 0.3s ease-in-out;\n  &:hover {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require("../../styles/colors");

var colors = _interopRequireWildcard(_colors);

var _breakpoints = require("../../styles/breakpoints");

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledInput = exports.StyledInput = _styledComponents2.default.input(_templateObject, function (props) {
  return props.inputColor || colors.inputColor;
}, function (props) {
  return props.fontSize || "16";
}, function (props) {
  return props.borderColor || colors.borderColor;
}, function (props) {
  return props.background || colors.inputBg;
}, function (props) {
  return props.innerSpace || "14px 14px";
}, function (props) {
  return props.inputRadius || "3";
}, function (props) {
  return props.placeholderColor || colors.placeholderColor;
}, function (props) {
  return props.placeholderFontSize || "13";
}, function (props) {
  return props.placeholderColor || colors.placeholderColor;
}, function (props) {
  return props.placeholderFontSize || "13";
}, function (props) {
  return props.placeholderColor || colors.placeholderColor;
}, function (props) {
  return props.placeholderFontSize || "13";
}, function (props) {
  return props.placeholderColor || colors.placeholderColor;
}, function (props) {
  return props.placeholderFontSize || "13";
});

var TextArea = exports.TextArea = (0, _styledComponents2.default)(StyledInput).attrs({
  as: "textarea"
})(_templateObject2);

var FormWrapper = exports.FormWrapper = (0, _styledComponents2.default)(_reactBootstrap.Container)(_templateObject3, function (props) {
  return props.background || colors.formBg;
}, function (props) {
  return props.textAlign || "center";
}, function (props) {
  return props.bodycolor || colors.blackColor;
}, function (props) {
  return props.formRadius || "4";
}, _breakpoints2.default.tabletL);

var Button = exports.Button = _styledComponents2.default.button(_templateObject4, function (props) {
  return props.buttonBg || colors.formBg;
}, function (props) {
  return props.color || colors.blackColor;
}, function (props) {
  return props.btnRadius || "3";
}, function (props) {
  return props.borderColor || colors.blackColor;
}, function (props) {
  return props.fontSize || "16";
}, function (props) {
  return props.hoverBg || colors.blackColor;
}, function (props) {
  return props.hoverColor || colors.whiteColor;
}, function (props) {
  return props.hoverBorderColor;
});